var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AmeliproErrorTemplate',{attrs:{"is-maintenance-message":"","error-type":"maintenance","custom-content-title":_vm.pageInfo.title,"custom-content-text":_vm.pageInfo.message,"no-button":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }